export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";